import { useEventListener } from '../useEventListener';
function useClickAnyWhere(handler) {
    useEventListener('click', function (event) {
        handler(event);
    });
}
export default useClickAnyWhere;
//# sourceMappingURL=useClickAnyWhere.js.map